import { http } from '@/plugins/http';

export const loadBrands = () => {
  return http.get('vikup/brands/');
};

export const loadModelsByBrandId = (brandId) => {
  return http.get(`vikup/models/?brand=${brandId}`);
};
